<script>
import AreaMap from './AreaMap.vue';
import currentDayLoan from '../views/currentDayLoan.vue';
import incomingChart from '../views/incomingChart.vue';
import loanBalance from '../views/loanBalance.vue'
import creditResult from '../views/creditResult.vue';
import bankList from '../views/bankList.vue'
import bankCharts from '../views/bankCharts.vue'
import after from '../views/after.vue'
import loanInfo from './loanInfo.vue';
import whiteList from '../views/whiteList.vue'
import whiteListChart from '../views/whiteListChart.vue';
import eeds from './../utils/eeds.json';
import xian from './../utils/xian.json';
import moment from "moment"

export default {
  name: '',
  props: ['msg', 'rightSelect'],
  components: {
    AreaMap, currentDayLoan, incomingChart, loanBalance, creditResult, bankList, after, loanInfo,
    bankCharts, whiteList, whiteListChart
  },
  data() {
    return {
      current: 0,
      areaCode: '610000',
      Arealist: [
        { name: '陕西省', value: '610000', data: xian},
        { name: '内蒙古自治区', value: '150000', data: eeds},
      ],
      rightTime: '',
      rightDate: '',
      rightWeek: ''
    }
  },
  created() {
    this.updateTime();
    this.getCurrentDateAndDayOfWeek();
  },
  methods: {
    handleCarouselChange(val) {
      this.current = val;
      this.areaCode = this.Arealist[val].value
    },
    updateTime() {
      setInterval(() => {
        const now = new Date();
        this.rightTime = moment(now).format('HH:mm:ss')
      }, 1000)
    },
    getCurrentDateAndDayOfWeek() {
      const date = new Date();
      this.rightDate = moment(date).format('YYYY.MM.DD'); // 获取日期
      this.rightWeek = date.toLocaleDateString('zh-CN', { weekday: 'long' }); // 获取星期（中文）
    }
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.intervalId);
  }
}
</script>


<template>
  <div class="big-screen">
    <el-container>
      <el-header style="height: 6vh;">
        <div style="height: 6vh;" class="d-flex hign-white ju-between item-center">
          <div></div>
          <div class="f-30">比邻乡村振兴数字化授信业务 数据驾驶舱</div>
          <div>
            <div class="f-12">{{ rightTime }}</div>
            <div class="f-10">{{ rightDate }} {{ rightWeek }}</div>
          </div>

        </div>
        <div class="d-flex">
          <dv-decoration-2 style="width:50%; height:2px;" />
          <dv-decoration-2 class="flip-horizontal" style="width:50%;height:2px;" />
        </div>
      </el-header>
      <el-main style="height: 94vh;" class="content">
        <div class="d-flex">
          <div style="width: 50%;">
            <currentDayLoan :current="current" class="flex-1"></currentDayLoan>
            <incomingChart :current="current" class="flex-1"></incomingChart>
            <loanBalance :current="current" class="flex-1"></loanBalance>
          </div>
          <div style="width: 50%;">
            <whiteList :current="current"></whiteList>
            <whiteListChart :current="current"></whiteListChart>
          </div>
        </div>

        <div class="d-flex ">
          <div style="width: 65%;">
            <loanInfo :current="current" style="height: 280px;"></loanInfo>
            <el-carousel height="660px" ref="carousel" style="height: 700px;" @change="handleCarouselChange" :interval="5000">
              <el-carousel-item v-for="(item, index) in Arealist" :key="item.value">
                <AreaMap v-if="current === index" :current="current" :areaCode="areaCode" :areaName="item.name" :cityList="item.data" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div style="width: 35%;">
            <bankList :current="current"></bankList>
            <bankCharts :current="current"></bankCharts>
          </div>
        </div>

        <div class="d-flex fl-dir-column ml-20">
          <creditResult :current="current" class="flex-1" style="height: 550px;"></creditResult>
          <after :current="current" class="flex-1" style="height: 600px;"></after>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<style lang="less" scoped>
.big-screen {
  font-size: 20px;
  .content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
